import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 19a2 2 0 1 1 4 0a2 2 0 0 1 -4 0","key":"svg-0"}],["path",{"d":"M12 3l-4.4 14.09","key":"svg-1"}],["path",{"d":"M19 3h-14","key":"svg-2"}]]

/**
 * IconPendulum
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGVuZHVsdW0iCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTUgMTlhMiAyIDAgMSAxIDQgMGEyIDIgMCAwIDEgLTQgMCIgLz4KICA8cGF0aCBkPSJNMTIgM2wtNC40IDE0LjA5IiAvPgogIDxwYXRoIGQ9Ik0xOSAzaC0xNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/pendulum
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPendulum = createReactComponent('outline', 'pendulum', 'Pendulum', __iconNode);

export default IconPendulum;